/**
 * Swiper 11.0.7
 * @url : https://swiperjs.com/api/
 */
// import Swiper JS
// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Navigation, Keyboard, Pagination, FreeMode, Mousewheel } from 'swiper/modules';

// Load Swiper with Drupal BigPipe Support
(function ($, Drupal) {
  Drupal.behaviors.LoadSwiper = {
    attach: function (context, settings) {
      /**
       * Swiper default
       */
      const Swipers = Array.from(context.getElementsByClassName('js-swiper'));
      if (Swipers.length) {
        for (const swiper of Swipers) {
          // Swiper instance
          const swiperInstance = new Swiper(swiper.querySelector('.swiper'), {
            modules: [Navigation, Keyboard],
            slidesPerView: 'auto',
            grabCursor: true,
            speed: 700,
            navigation: {
              nextEl: swiper.querySelector('.swiper-button-next'),
              prevEl: swiper.querySelector('.swiper-button-prev'),
            },
            keyboard: true,
            init: false,
          });

          // Init only if there is 2 or more slides
          const nbSlides = Array.from(swiper.getElementsByClassName('swiper-slide'));
          if (nbSlides.length > 1) swiperInstance.init();
        }
      }

      /**
       * Swiper freemode
       */
      const SwipersFree = Array.from(context.getElementsByClassName('js-swiper-freemode'));
      if (SwipersFree.length) {
        for (const swiper of SwipersFree) {
          // Swiper instance
          const swiperFreemodeInstance = new Swiper(swiper.querySelector('.swiper-free-mode'), {
            modules: [Navigation, Pagination, FreeMode, Keyboard],
            slidesPerView: 'auto',
            centeredSlides: Foundation.MediaQuery.current !== 'small',
            grabCursor: true,
            freeMode: true,
            spaceBetween: Foundation.MediaQuery.current === 'small' ? 16 : 32,
            speed: 700,
            navigation: {
              nextEl: swiper.querySelector('.swiper-button-next'),
              prevEl: swiper.querySelector('.swiper-button-prev'),
            },
            keyboard: true,
            init: false,
          });

          // Init only if there is 2 or more slides
          const nbSlides = Array.from(swiper.getElementsByClassName('swiper-slide'));
          if (nbSlides.length > 1) swiperFreemodeInstance.init();
        }
      }

      /**
       * Swiper anchors
       */
      const SwipersAnchors = Array.from(context.getElementsByClassName('js-swiper-anchors'));
      if (SwipersAnchors.length) {
        for (const swiper of SwipersAnchors) {
          // Swiper instance
          const swiperAnchorsInstance = new Swiper(swiper.querySelector('.swiper-anchors'), {
            modules: [Keyboard, FreeMode, Mousewheel],
            slidesPerView: 'auto',
            spaceBetween: 12,
            grabCursor: 'true',
            mousewheel: true,
            init: false,
          });

          // Init only if there is 2 or more slides
          const nbSlides = Array.from(swiper.getElementsByClassName('swiper-slide'));
          if (nbSlides.length > 1) swiperAnchorsInstance.init();
        }
      }
    },
  };
})(jQuery, Drupal);
